export default __webpack_public_path__ + "static/media/Yelpcamp.65d2e971.jpg";